import { useShowNotification } from '@inflearn/ds-react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { useBeforeUnloadEvent } from '../../../../hooks/useBeforeUnloadEvent';
import useNoteIdUpdateMutation, {
  getUseNoteIdUpdateMutationQueryKey,
} from '../../../../mutations/useNoteIdUpdateMutation';
import { getUseNoteIdWithUnitsQueryKey } from './queries/useNoteIdWithUnitsQuery';

export function useEditNote(noteId: string, initialBody: string, courseNoteId: string) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const [noteBody, setNoteBody] = useState(initialBody);
  const [isEditMode, setIsEditMode] = useState(false);
  const { showNotification } = useShowNotification();

  /* 페이지 이탈 시 수정 중일 경우 경고 표시 */
  useBeforeUnloadEvent(!isEditMode);

  const { mutate: updateMutate } = useNoteIdUpdateMutation(noteId, {
    mutationKey: getUseNoteIdUpdateMutationQueryKey(noteId),
    onSuccess: (_, updatedNote) => {
      setNoteBody(updatedNote.body);
      setIsEditMode(false);
      void queryClient.invalidateQueries(getUseNoteIdWithUnitsQueryKey(courseNoteId));
    },
    onError: () => {
      showNotification({
        type: 'error',
        title: t('노트 수정 실패'),
        message: t('잠시 후 다시 시도해 주세요.'),
      });
    },
  });

  const handleClickEdit = () => {
    setIsEditMode(true);
  };

  const handleCancelEdit = () => {
    setIsEditMode(false);
  };

  const handleSubmitEdit = async (body: string) => {
    updateMutate({ body });
  };

  return { noteBody, isEditMode, handleClickEdit, handleCancelEdit, handleSubmitEdit };
}

export default useEditNote;
